"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _styles = require("@material-ui/core/styles");

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      overflow: 'hidden',
      '& > div:last-of-type': {
        width: 'auto',
        marginLeft: 'auto',
        '& span': {
          fontSize: 18
        }
      }
    },
    image: {
      width: 45,
      height: 45
    },
    name: {
      width: '100%',
      maxWidth: 150,
      overflow: 'hidden'
    },
    priceGrid: {
      width: 'auto'
    }
  };
}, {
  name: 'SxDocumentSearchItem'
});

function DocumentSearchItem(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      item = _ref.item,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "item"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var limitedName = t(item.name).length >= 25 ? "".concat(t(item.name).slice(0, 25), "...") : t(item.name);
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    component: "div",
    disableGutters: true
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.name
  }, limitedName));
}

process.env.NODE_ENV !== "production" ? DocumentSearchItem.propTypes = {
  classes: _propTypes.default.shape({
    image: _propTypes.default.string,
    name: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  item: _propTypes.default.shape({
    image: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string)),
    name: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired
} : void 0;
DocumentSearchItem.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = DocumentSearchItem;
exports.default = _default;